module.exports = __webpack_public_path__ + "static/media/27.606d3202.png";